import React from 'react';
export function Footer() {
  return <footer className="w-full px-5 py-10" data-id="element-175" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-2xl text-center" data-id="element-176" data-mp="3gf96t1ka0gbl">
        <p className="font-display text-base font-semibold text-ink" data-id="element-177" data-mp="3ggtx2ezk5d3n">
          Wizualna Chemia™ | Edycja 2026
        </p>
        <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-178" data-mp="32lrn9grlb3lk">
          Produkt cyfrowy • Jednorazowa płatność • Bez abonamentu
        </p>
        <p className="mt-3 text-xs leading-relaxed text-ink/45" data-id="element-179" data-mp="3uesani6215i3">
          Materiały przeznaczone do własnej pracy nauczyciela z uczniami.
        </p>
      </div>
    </footer>;
}